import React, {Fragment} from 'react';
import Button from "../form/Button";
import Select from "../form/Select";
import DateTimeInput from "../form/DateTimeInput";
import {optionsTemplate, ProductColumn, UnitFormatter} from "../../utils/formatters";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import Tabs from "../layout/Tabs";
import TabContent from "../layout/TabContent";
import {loadComponent} from "../../utils/components";
import PeriodInput from "../form/PeriodInput";
import createEditor from "../form/ComponentEditor";
import connect from "react-redux/es/connect/connect";

const sortable = true;
const filterable = true;

class StockMovementsEditor extends React.Component {

    state = {
        values: {},
        params: {}
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    setFieldValue = (field, value) => {
        if (field === "product") {
            this.productRequest && this.productRequest.abort();
            this.productRequest = loadComponent("componentlist", {
                component: "product",
                itemsperpage: 0,
                view: ["id"],
                filter: {field: "base_product_id", value: value.base_product_id}
            });
            this.productRequest.then((list) => {
                this.setState({values: {...this.state.values, products: list.items.map((product) => product.id)}});
            });
            value = value.id;
        }
        this.setState({values: {...this.state.values, [field]: value}});
    }

    render() {
        const list = (type, types, fields, aggregations, key) => {
            const params = {...this.state.params};
            if (type.indexOf("_move") === -1) {
                if (params.date) {
                    params.date = [...params.date];
                    params.date[0] = null;
                }
            }
            return <div className="row">
                <div className="col-md-12">
                    {!(Array.isArray(types) ? types.find((type) => !this.state.params[type]) : Object.keys(types).filter((type) => types[type]).find((type) => !this.state.params[type])) &&
                    <SelectorGrid
                        key={key}
                        className="p-small-table"
                        component="CalculatedStockItem"
                        view={["product.id"]}
                        parameters={{
                            stock_type: type,
                            ...Object.keys(types).reduce((all, current) => (all[current] = params[current], all), {})
                        }}
                        exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"/*, browserExport: {type: "excel", filename: "lista.xlsx"}*/}]}
                        sortBy={{
                            field: fields.transaction_date ? "transaction_date" : "product.displayname",
                            direction: fields.transaction_date ? "desc" : "asc"
                        }}
                        orderBy={{
                            field: fields.transaction_date ? "transaction_date" : "product.displayname",
                            direction: fields.transaction_date ? "desc" : "asc"
                        }}
                        aggregations={aggregations}
                        columns={fields}
                    />}
                </div>
            </div>;
        }
        const fields = {
            product: (size, props) => <div className={"col-md-" + size}>
                <div className="form-group">
                    <Select
                        label="Termék"
                        name="product"
                        objectValue={true}
                        component="product"
                        labelKey="displayname"
                        storeType="remote"
                        view={["base_product_id"]}
                        optionsTemplate={optionsTemplate("product")}
                        value={this.state.values.product}
                        saveChanges={this.setFieldValue}
                        {...props}
                    />
                </div>
            </div>,
            partner: (size, props) => <div className={"col-md-" + size}>
                <div className="form-group">
                    <Select
                        label="Partner"
                        name="partner"
                        component="partner"
                        labelKey="name"
                        storeType="remote"
                        objectValue={false}
                        optionsTemplate={optionsTemplate("partner")}
                        value={this.state.values.partner}
                        saveChanges={this.setFieldValue}
                        {...props}
                    />
                </div>
            </div>,
            store: (size, props) => <div className={"col-md-" + size}>
                <div className="form-group">
                    <Select
                        label="Raktár"
                        name="store"
                        component="location"
                        labelKey="name"
                        storeType="local"
                        objectValue={false}
                        optionsTemplate={optionsTemplate("location")}
                        value={this.state.values.store}
                        saveChanges={this.setFieldValue}
                        filter={[
                            {
                                field: "partner",
                                value: this.props.till.pos.partner.partner_id
                            },
                            {
                                field: "roles.optionid",
                                value: "4" // ShopSupplyStore
                            }
                        ]}
                        {...props}
                    />
                </div>
            </div>,
            date: (size, props) => <div className={"col-md-" + size}>
                <div className="form-group">
                    {props.period ? <PeriodInput
                        year={true}
                        periodChangeType="default"
                        value={this.state.values.date ? this.state.values.date.map((date) => date ? date.split(" ")[0] : null) : null}
                        label="Dátum"
                        saveChanges={(field, value) => {
                            this.setFieldValue("date", value.map((date, i) => date ? (i === 0 ? date + " 00:00:00" : date + " 23:59:59") : date));
                        }}
                        {...props}
                    /> : <DateTimeInput
                        value={this.state.values.date ? this.state.values.date[1] : null}
                        label="Dátum"
                        isClearable={!props.required}
                        saveChanges={(field, date) => {
                            this.setFieldValue("date", date ? [null, date + " 23:59:59"] : [null, null]);
                        }}
                        {...props}
                    />}
                </div>
            </div>
        }
        const tabs = [
            {
                type: "partner_stock",
                label: "Bizományos partner készlete",
                types: {"partner": true, date: false},
                filters: <div className="row">
                    {fields.partner(6, {required: true})}
                    {fields.date(6, {period: false})}
                </div>,
                aggregations: {
                    fields: {
                        shipped: {
                            type: "SUM"
                        },
                        returned: {
                            type: "SUM"
                        },
                        paid: {
                            type: "SUM"
                        },
                        qty: {
                            type: "SUM"
                        }
                    }
                },
                fields: {
                    "product.displayname": {
                        ...ProductColumn("product.id")
                    },
                    "product.barcode": {
                        header: 'Vonalkód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "product.tradename.name": {
                        header: 'Kiadó',
                        width: 1,
                        sortable,
                        filterable,
                    },
                    "shipped": {
                        header: "Szállítva",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, "db")
                    },
                    "returned": {
                        header: "Visszáru",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, "db")
                    },
                    "paid": {
                        header: "Elszámolva",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, "db")
                    },
                    "qty": {
                        header: "Készleten",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, "db")
                    },
                }
            },
            {
                type: "partner_stock_move",
                label: "Bizományos partner készletének mozgása",
                types: {"partner": true,"products": true, "date": false},
                filters: <div className="row">
                    {fields.product(3, {required: true})}
                    {fields.partner(3, {required: true})}
                    {fields.date(6, {required: true, period: true})}
                </div>,
                fields: {
                    "product.displayname": {
                        ...ProductColumn("product.id")
                    },
                    "product.barcode": {
                        header: 'Vonalkód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "transaction_date": {
                        header: "Tranzakció dátuma",
                        width: 2,
                        sortable,
                        filterable,
                    },
                    "transaction_type": {
                        header: "Típus",
                        width: 1,
                        sortable,
                        filterable,
                    },
                    "transaction_labels": {
                        header: "Bizonylatok",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value) => (value || "").split("\n").map((item, key) => {
                            return <Fragment key={key}>{item}<br/></Fragment>
                        })
                    },
                    "qty": {
                        header: "Darabszám",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, "db")
                    },
                }
            },
            {
                type: "consigned_stock",
                label: "Bizományos készlet",
                types: {"partner": true, "date": false},
                filters: <div className="row">
                    {fields.partner(6, {required: true})}
                    {fields.date(6, {period: false})}
                </div>,
                aggregations: {
                    fields: {
                        shipped: {
                            type: "SUM"
                        },
                        returned: {
                            type: "SUM"
                        },
                        paid: {
                            type: "SUM"
                        },
                        qty: {
                            type: "SUM"
                        }
                    }
                },
                fields: {
                    "product.displayname": {
                        ...ProductColumn("product.id")
                    },
                    "product.barcode": {
                        header: 'Vonalkód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "product.tradename.name": {
                        header: 'Kiadó',
                        width: 1,
                        sortable,
                        filterable,
                    },
                    "shipped": {
                        header: "Szállítva",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, "db")
                    },
                    "returned": {
                        header: "Visszáru",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, "db")
                    },
                    "paid": {
                        header: "Elszámolva",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, "db")
                    },
                    "qty": {
                        header: "Készleten",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, "db")
                    },
                }
            },
            {
                type: "consigned_stock_move",
                label: "Bizományos készlet mozgása",
                types: {"partner": true, "products": true, "date": false},
                filters: <div className="row">
                    {fields.product(3, {required: true})}
                    {fields.partner(3, {required: true})}
                    {fields.date(6, {required: true, period: true})}
                </div>,
                fields: {
                    "product.displayname": {
                        ...ProductColumn("product.id")
                    },
                    "product.barcode": {
                        header: 'Vonalkód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "transaction_date": {
                        header: "Tranzakció dátuma",
                        width: 2,
                        sortable,
                        filterable,
                    },
                    "transaction_labels": {
                        header: "Bizonylatok",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value) => (value || "").split("\n").map((item, key) => {
                            return <Fragment key={key}>{item}<br/></Fragment>
                        })
                    },
                    "shipped": {
                        header: "Szállítva",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, "db")
                    },
                    "returned": {
                        header: "Visszáru",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, "db")
                    },
                    "paid": {
                        header: "Elszámolva",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, "db")
                    },
                    "qty": {
                        header: "Készleten",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, "db")
                    },
                }
            },
            {
                type: "store_stock",
                label: "Belső raktár készlete",
                types: {"store": true, "date": false},
                filters: <div className="row">
                    {fields.store(6, {required: true})}
                    {fields.date(6, {period: false})}
                </div>,
                fields: {
                    "product.displayname": {
                        ...ProductColumn("product.id")
                    },
                    "product.barcode": {
                        header: 'Vonalkód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "product.tradename.name": {
                        header: 'Kiadó',
                        width: 1,
                        sortable,
                        filterable,
                    },
                    "qty": {
                        header: "Darabszám",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, "db")
                    },
                }
            },
            {
                type: "store_stock_move",
                label: "Belső raktár készletének mozgása",
                types: {"products": true, "store": true, "date": false},
                filters: <div className="row">
                    {fields.product(3, {required: true})}
                    {fields.store(3, {required: true})}
                    {fields.date(6, {required: true, period: true})}
                </div>,
                aggregations: {
                    fields: {
                        shipped: {
                            type: "SUM"
                        },
                        returned: {
                            type: "SUM"
                        },
                        paid: {
                            type: "SUM"
                        },
                        qty: {
                            type: "SUM"
                        }
                    }
                },
                fields: {
                    "product.displayname": {
                        ...ProductColumn("product.id")
                    },
                    "product.barcode": {
                        header: 'Vonalkód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "transaction_date": {
                        header: "Tranzakció dátuma",
                        width: 2,
                        sortable,
                        filterable,
                    },
                    "transaction_type": {
                        header: "Típus",
                        width: 1,
                        sortable,
                        filterable,
                    },
                    "transaction_labels": {
                        header: "Bizonylatok",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value) => (value || "").split("\n").map((item, key) => {
                            return <Fragment key={key}>{item}<br/></Fragment>
                        })
                    },
                    "origin": {
                        header: "Honnan",
                        width: 1,
                        sortable,
                        filterable,
                    },
                    "destination": {
                        header: "Hova",
                        width: 1,
                        sortable,
                        filterable,
                    },
                    "qty": {
                        header: "Darabszám",
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, "db")
                    },
                }
            },
        ].filter((tab) => this.props.id && tab.type.indexOf(this.props.id) !== -1);
        const disabled = JSON.stringify(this.state.values) === JSON.stringify(this.state.params);
        return <Fragment>
            <Tabs
                defaultTab="list_0"
                theme="default"
            >
                {tabs.map((tab, index) => {
                    const notset = !!Object.keys(tab.types).find((type) => tab.types[type] && !this.state.values[type]);
                    return (
                        <TabContent tabLabel={tab.label} tabName={"list_" + index}>
                            {tab.filters}
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <Button
                                            color={disabled || notset ? "default" : "warning"}
                                            disabled={disabled || notset}
                                            block={true}
                                            icon={{lib: "fa", name: "search"}}
                                            onClick={() => {
                                                this.setState({params: this.state.values});
                                            }}
                                        >
                                            Szűrés
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            {list(tab.type, tab.types, tab.fields, tab.aggregations, index)}
                        </TabContent>
                    )
                })}
            </Tabs>
        </Fragment>;
    }
}

const Editors = {};

export default (props) => {
    if (!props.id) return null;
    props = {...props};
    let Editor;
    if (!Editors[props.id]) {
        Editors[props.id] = Editor = connect((state) => {
            return {
                till: state.app.till
            };
        }, {})(createEditor({
            componentName: "CalculatedStockItem",
            WrappedComponent: StockMovementsEditor,
            editor: "StockMovements" + props.id
        }));
    } else {
        Editor = Editors[props.id];
    }
    if (props.setContent) {
        props.setContent = (content, props) => props.setContent("StockMovements", props)
    }
    return <Editor {...props} />;
};